/* i18n-module-v */
var __i18nLang = ((document.documentElement.getAttribute('lang') || 'en').toLowerCase());  /* var, not const: two theme assets declare this and const made the second file throw */
var __i18nLoc = __i18nLang.startsWith('es') ? 'es' : (__i18nLang.startsWith('pt') ? 'pt' : (__i18nLang.startsWith('fr') ? 'fr' : (__i18nLang.startsWith('de') ? 'de' : 'en')));
function __t(en, es, pt, fr, de) { return __i18nLoc === 'es' ? es : (__i18nLoc === 'pt' ? pt : (__i18nLoc === 'fr' && fr ? fr : (__i18nLoc === 'de' && de ? de : en))); }
(() => {
  function initPackBuilder(root) {
    if (!root || root.dataset.packBuilderReady === "true") return;
    root.dataset.packBuilderReady = "true";

    const productsEl = document.querySelector("[data-pack-products-json]");

    const gallery = root.querySelector("[data-pack-gallery]");
    const atc = root.querySelector("[data-pack-atc]");
    const error = root.querySelector("[data-pack-error]");
    const salePriceEls = root.querySelectorAll("[data-pack-sale-price]");
    const atcPriceEl = root.querySelector("[data-atc-price]");
    const compareEl = root.querySelector("[data-pack-compare-price]");
    const saveBadge = root.querySelector("[data-pack-save-badge]");

    const bundleName = root.dataset.bundleName || __t("Bundle & Save", "Combina y ahorra", "Combine e economize", "Combinez et économisez", "Kombinieren & sparen");
    const sizeOptionName = root.dataset.sizeOptionName || "Size";

    let products = {};
    let selections = {};

    try {
      products = JSON.parse(productsEl?.textContent || "{}");
    } catch (e) {
      console.error("Pack builder JSON error:", e);
      return;
    }

    root.querySelectorAll('input[name="option2"]').forEach((input) => {
      input.checked = false;
      input.removeAttribute("checked");
    });



    function money(cents) {
      const amount = Number(cents || 0) / 100;
      const currencyCode = root.dataset.currencyCode || "USD";

      try {
        return new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currencyCode,
          currencyDisplay: "narrowSymbol"
        }).format(amount);
      } catch (e) {
        return new Intl.NumberFormat(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount) + " " + currencyCode;
      }
    }





    function selectedOption(position) {
      const input = root.querySelector(`input[name="option${position}"]:checked`);
      return input ? input.value : "";
    }

    function selectedPack() {
      return selectedOption(1);
    }

    function selectedSize() {
      return selectedOption(2);
    }

    function packCount() {
      const match = selectedPack().match(/\d+/);
      return match ? Number(match[0]) : 0;
    }

    function discountPercent() {
      const count = packCount();
      return Number(root.getAttribute(`data-discount-${count}`) || 0);
    }

    function makeBundleId() {
      const a = Math.random().toString(36).slice(2, 10).toUpperCase();
      const b = Date.now().toString(36).slice(-8).toUpperCase();
      return `${a}${b}`;
    }

    function findSourceVariant(product, size) {
      if (!product || !Array.isArray(product.variants)) return null;

      return product.variants.find((variant) => {
        return variant.options && variant.options[sizeOptionName] === size;
      });
    }

    function getBaseVariantForSize() {
      const size = selectedSize();

      for (const handle in products) {
        const variant = findSourceVariant(products[handle], size);
        if (variant && variant.available) return variant;
      }

      for (const handle in products) {
        const variant = findSourceVariant(products[handle], size);
        if (variant) return variant;
      }

      return null;
    }

    function getSelectedVariants() {
      const count = packCount();
      const size = selectedSize();
      const selected = [];

      for (let slot = 1; slot <= count; slot++) {
        const handle = selections[slot];
        if (!handle) continue;

        const product = products[handle];
        const variant = findSourceVariant(product, size);

        if (variant) {
          selected.push({
            slot,
            handle,
            product,
            variant
          });
        }
      }

      return selected;
    }

    function calculatePrices() {
      const count = packCount();
      const discount = discountPercent();
      const selected = getSelectedVariants();

      let compareCents = 0;

      if (selected.length > 0) {
        selected.forEach((item) => {
          compareCents += Number(item.variant.price || 0);
        });

        const missingSlots = count - selected.length;
        const baseVariant = getBaseVariantForSize();
        compareCents += missingSlots * Number(baseVariant?.price || 0);
      } else {
        const baseVariant = getBaseVariantForSize();
        compareCents = count * Number(baseVariant?.price || 0);
      }


      let saleCents = 0;
      if (selected.length > 0) {
        selected.forEach((item) => {
          saleCents += Math.ceil(Number(item.variant.price || 0) * (100 - discount) / 100);
        });
        const missingSlots = count - selected.length;
        const baseVariant = getBaseVariantForSize();
        for (let i = 0; i < missingSlots; i++) {
          saleCents += Math.ceil(Number(baseVariant?.price || 0) * (100 - discount) / 100);
        }
      } else {
        const baseVariant = getBaseVariantForSize();
        for (let i = 0; i < count; i++) {
          saleCents += Math.ceil(Number(baseVariant?.price || 0) * (100 - discount) / 100);
        }
      }
      const saveCents = Math.max(compareCents - saleCents, 0);



      return {
        count,
        discount,
        compareCents,
        saleCents,
        saveCents
      };
    }

    function clearError() {
      if (!error) return;
      error.hidden = true;
      error.textContent = "";
    }

    function showError(message) {
      if (!error) return;
      error.hidden = false;
      error.textContent = message;
    }


    function updateDisplayedPrice() {
      const hasSize = !!selectedSize();

      if (!hasSize) {
        salePriceEls.forEach((el) => {
          el.hidden = true;
          el.textContent = "";
          el.style.display = "none";
        });

        if (compareEl) {
          compareEl.hidden = true;
          compareEl.textContent = "";
          compareEl.style.display = "none";
        }

        if (saveBadge) {
          saveBadge.hidden = true;
          saveBadge.textContent = "";
          saveBadge.style.display = "none";
        }

        if (atcPriceEl) {
          atcPriceEl.hidden = true;
          atcPriceEl.innerHTML = "";
          atcPriceEl.style.display = "none";
        }

        return;
      }

      const prices = calculatePrices();

      const saleText = money(prices.saleCents);
      const compareText = money(prices.compareCents);
      const saveText = "Save " + money(prices.saveCents);

      salePriceEls.forEach((el) => {
        el.hidden = false;
        el.removeAttribute("hidden");
        el.style.display = "";
        el.textContent = saleText;
      });

      if (compareEl) {
        compareEl.hidden = !(prices.compareCents > prices.saleCents);
        compareEl.style.display = prices.compareCents > prices.saleCents ? "" : "none";
        compareEl.textContent = compareText;
      }

      if (saveBadge) {
        saveBadge.hidden = !(prices.saveCents > 0);
        saveBadge.style.display = prices.saveCents > 0 ? "" : "none";
        saveBadge.textContent = saveText;
      }

      if (atcPriceEl) {
        atcPriceEl.hidden = false;
        atcPriceEl.removeAttribute("hidden");
        atcPriceEl.style.display = "";

        if (prices.compareCents > prices.saleCents) {
          atcPriceEl.innerHTML = `
            <span class="pack-builder-atc-dot">•</span>
            <span class="pack-builder-atc-compare">${compareText}</span>
            <span class="pack-builder-atc-sale">${saleText}</span>
          `;
        } else {
          atcPriceEl.innerHTML = `
            <span class="pack-builder-atc-dot">•</span>
            <span class="pack-builder-atc-sale">${saleText}</span>
          `;
        }
      }
    }





    function enablePickerDragScroll(scroller) {
      if (!scroller || scroller.dataset.dragScrollReady === "true") return;

      scroller.dataset.dragScrollReady = "true";

      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;

      scroller.addEventListener("wheel", (event) => {
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        event.preventDefault();
        scroller.scrollLeft += event.deltaY;
      }, { passive: false });

      scroller.addEventListener("pointerdown", (event) => {
        isDown = true;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.dataset.wasDragging = "false";
      });

      scroller.addEventListener("pointermove", (event) => {
        if (!isDown) return;

        const distance = event.clientX - startX;

        if (Math.abs(distance) > 6) {
          scroller.dataset.wasDragging = "true";
          scroller.classList.add("is-dragging");
          scroller.scrollLeft = startScrollLeft - distance;
        }
      });

      function endDrag() {
        isDown = false;
        scroller.classList.remove("is-dragging");

        setTimeout(() => {
          scroller.dataset.wasDragging = "false";
        }, 120);
      }

      scroller.addEventListener("pointerup", endDrag);
      scroller.addEventListener("pointercancel", endDrag);
      scroller.addEventListener("mouseleave", endDrag);
    }






    function closeSlotPickers() {
      gallery?.querySelectorAll(".pack-builder-slot-picker").forEach((picker) => {
        picker.remove();
      });
    }





    function openSizePicker(slotEl) {
      if (!slotEl) return;

      closeSlotPickers();

      const sizeInputs = root.querySelectorAll('input[name="option2"]');
      if (!sizeInputs.length) return;

      const picker = document.createElement("div");
      picker.className = "pack-builder-slot-picker pack-builder-slot-picker--sizes";

      const prompt = document.createElement("div");
      prompt.className = "pack-builder-slot-picker__prompt";

      const target = document.createElement("span");
      target.className = "pack-builder-slot-picker__target";
      target.setAttribute("aria-hidden", "true");

      const text = document.createElement("span");
      text.className = "pack-builder-slot-picker__prompt-text";
      text.textContent = __t("Select size first", "Elige primero la talla", "Escolha o tamanho primeiro", "Choisissez d'abord la taille", "Wähl zuerst deine Größe");

      prompt.appendChild(target);
      prompt.appendChild(text);

      const options = document.createElement("div");
      options.className = "pack-builder-slot-picker__sizes";

      sizeInputs.forEach((input) => {
        const option = document.createElement("button");
        option.type = "button";
        option.className = "pack-builder-slot-picker__size";
        option.textContent = input.value;
        option.setAttribute("aria-label", `Select size ${input.value}`);

        if (input.checked) {
          option.classList.add("is-selected");
        }


        option.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          root.querySelectorAll('input[name="option2"]').forEach((otherInput) => {
            otherInput.checked = otherInput === input;
          });

          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));

          closeSlotPickers();
          clearError();
          updateRowsAndGallery();
        });

        options.appendChild(option);
      });

      picker.appendChild(prompt);
      picker.appendChild(options);
      slotEl.appendChild(picker);

    }


















    

    function openSlotPicker(slotEl, slot) {
      if (!slotEl) return;

      closeSlotPickers();

      const row = root.querySelector(`[data-swatch-row="${slot}"]`);
      if (!row) return;

      const picker = document.createElement("div");
      picker.className = "pack-builder-slot-picker";

      row.querySelectorAll("[data-style-handle]").forEach((sourceButton) => {
        if (sourceButton.disabled) return;

        const handle = sourceButton.dataset.styleHandle;
        const product = products[handle];
        const sourceSwatch = sourceButton.querySelector("span");

        const option = document.createElement("button");
        option.type = "button";
        option.className = "pack-builder-slot-picker__option";
        option.setAttribute("aria-label", product?.title || __t("Select style", "Elige un estilo", "Escolha um estilo", "Choisissez un style", "Modell wählen"));

        if (sourceButton.classList.contains("is-selected")) {
          option.classList.add("is-selected");
        }

        const swatch = document.createElement("span");
        swatch.style.backgroundImage = sourceSwatch?.style.backgroundImage || "";
        option.appendChild(swatch);

        option.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          sourceButton.click();
          closeSlotPickers();
        });

        picker.appendChild(option);
      });

      slotEl.appendChild(picker);
      enablePickerDragScroll(picker);
    }


    function placeholderText(slot) {
      if (!selectedSize()) {
        return __t("Select size first", "Elige primero la talla", "Escolha o tamanho primeiro", "Choisissez d'abord la taille", "Wähl zuerst deine Größe");
      }

      const suffix =
        slot === 1 ? "st" :
        slot === 2 ? "nd" :
        slot === 3 ? "rd" : "th";

      return `Add your ${slot}${suffix} item`;
    }


    function clearGallerySlot(slot) {
      const slotEl = gallery?.querySelector(`[data-gallery-slot="${slot}"]`);
      if (!slotEl) return;

      const placeholder = slotEl.querySelector(".pack-builder-gallery__placeholder");
      const img = slotEl.querySelector("img");
      const dots = slotEl.querySelector("[data-gallery-thumbs]");

      if (placeholder) {
        placeholder.hidden = false;
        placeholder.textContent = placeholderText(slot);
        placeholder.setAttribute("role", "button");
        placeholder.setAttribute("tabindex", "0");
        placeholder.style.cursor = "pointer";


        placeholder.onclick = (event) => {
          event.preventDefault();
          event.stopPropagation();

          const existingPicker = slotEl.querySelector(".pack-builder-slot-picker");

          if (existingPicker) {
            closeSlotPickers();
            return;
          }

          if (!selectedSize()) {
            openSizePicker(slotEl);
            return;
          }

          openSlotPicker(slotEl, slot);
        };



        placeholder.onkeydown = (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            placeholder.click();
          }
        };
      }

      if (img) {
        img.hidden = true;
        img.removeAttribute("src");
        img.alt = "";
      }

      if (dots) {
        dots.innerHTML = "";
        dots.hidden = true;
      }
    }






        function updateGallerySlot(slot, handle) {
          const product = products[handle];
          const slotEl = gallery?.querySelector(`[data-gallery-slot="${slot}"]`);
          if (!product || !slotEl) return;

          const placeholder = slotEl.querySelector(".pack-builder-gallery__placeholder");
          const img = slotEl.querySelector("img");

          let dots = slotEl.querySelector("[data-gallery-thumbs]");

          if (!dots) {
            dots = document.createElement("div");
            dots.className = "pack-builder-gallery__thumbs";
            dots.setAttribute("data-gallery-thumbs", "");
            slotEl.appendChild(dots);
          }

          const images = Array.isArray(product.images) && product.images.length
            ? product.images
            : [{ src: product.image, alt: product.title }];

          let currentIndex = 0;
          let touchStartX = 0;
          let touchStartY = 0;

          function showImage(index) {
            if (!images.length) return;

            currentIndex = index;

            if (currentIndex < 0) currentIndex = images.length - 1;
            if (currentIndex >= images.length) currentIndex = 0;

            const image = images[currentIndex];

            if (img) {
              img.src = image.src;
              img.alt = image.alt || product.title;
              img.hidden = false;
            }

            dots.querySelectorAll(".pack-builder-gallery__thumb").forEach((button, buttonIndex) => {
              button.classList.toggle("is-selected", buttonIndex === currentIndex);
            });
          }

          if (placeholder) placeholder.hidden = true;

          dots.innerHTML = "";
          dots.hidden = images.length <= 1;

          images.forEach((image, index) => {
            const button = document.createElement("button");
            button.type = "button";
            button.className = "pack-builder-gallery__thumb";
            button.setAttribute("aria-label", `View image ${index + 1} for ${product.title}`);

            button.addEventListener("click", () => {
              showImage(index);
            });

            dots.appendChild(button);
          });

          showImage(0);

          slotEl.ontouchstart = (event) => {
            if (!event.touches || event.touches.length !== 1) return;

            touchStartX = event.touches[0].clientX;
            touchStartY = event.touches[0].clientY;
          };

          slotEl.ontouchend = (event) => {
            if (!event.changedTouches || event.changedTouches.length !== 1) return;
            if (images.length <= 1) return;

            const touchEndX = event.changedTouches[0].clientX;
            const touchEndY = event.changedTouches[0].clientY;

            const diffX = touchStartX - touchEndX;
            const diffY = touchStartY - touchEndY;

            if (Math.abs(diffX) < 35) return;
            if (Math.abs(diffX) < Math.abs(diffY)) return;

            if (diffX > 0) {
              showImage(currentIndex + 1);
            } else {
              showImage(currentIndex - 1);
            }
          };
        }

                  



    function updateSoldoutStates() {
      const size = selectedSize();

      root.querySelectorAll("[data-swatch-row]").forEach((row) => {
        if (row.hidden) return;

        const slot = Number(row.dataset.swatchRow);

        row.querySelectorAll("[data-style-handle]").forEach((button) => {
          const handle = button.dataset.styleHandle;
          const product = products[handle];
          const variant = findSourceVariant(product, size);
          const soldout = !variant || !variant.available;

          button.classList.toggle("is-soldout", soldout);
          button.disabled = soldout;

          if (soldout && selections[slot] === handle) {
            delete selections[slot];
            button.classList.remove("is-selected");
            clearGallerySlot(slot);
          }
        });
      });
    }

    function updateAtcState() {
      const count = packCount();
      let ready = count > 0;

      for (let i = 1; i <= count; i++) {
        if (!selections[i]) ready = false;
      }

      if (atc) atc.disabled = !ready;
    }

    function updateRowsAndGallery() {
      const count = packCount();

      root.querySelectorAll("[data-swatch-row]").forEach((row) => {
        const slot = Number(row.dataset.swatchRow);

        if (slot <= count) {
          row.hidden = false;
          row.style.display = "";
        } else {
          row.hidden = true;
          row.style.display = "none";
          delete selections[slot];
        }

        const label = row.querySelector("[data-row-label]");
        if (label) {
        const selectedHandle = selections[slot];
        const selectedProduct = selectedHandle ? products[selectedHandle] : null;
        label.textContent = selectedProduct ? selectedProduct.title : "Style";
        }


      });

      gallery?.querySelectorAll("[data-gallery-slot]").forEach((slotEl) => {
        const slot = Number(slotEl.dataset.gallerySlot);

        if (slot <= count) {
          slotEl.hidden = false;
          slotEl.style.display = "";
        } else {
          slotEl.hidden = true;
          slotEl.style.display = "none";
          clearGallerySlot(slot);
        }

        if (slot <= count) {
          if (selections[slot]) {
            updateGallerySlot(slot, selections[slot]);
          } else {
            clearGallerySlot(slot);
          }
        }
      });

      updateSoldoutStates();
      updateDisplayedPrice();
      updateAtcState();
    }

    root.querySelectorAll("[data-shell-option]").forEach((input) => {
      input.addEventListener("change", () => {
        closeSlotPickers();
        clearError();
        updateRowsAndGallery();
      });
    });






    root.querySelectorAll("[data-style-handle]").forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) return;

        const row = button.closest("[data-swatch-row]");
        const slot = Number(row.dataset.swatchRow);
        const handle = button.dataset.styleHandle;
        const wasSelected = selections[slot] === handle;

        row.querySelectorAll("[data-style-handle]").forEach((other) => {
          other.classList.remove("is-selected");
        });

        if (wasSelected) {
          delete selections[slot];

          const label = row.querySelector("[data-row-label]");
          if (label) {
            label.textContent = "Style";
          }

          clearGallerySlot(slot);
          clearError();
          updateDisplayedPrice();
          updateAtcState();
          return;
        }

        button.classList.add("is-selected");
        selections[slot] = handle;

        const label = row.querySelector("[data-row-label]");
        if (label && products[handle]) {
          label.textContent = products[handle].title;
        }

        updateGallerySlot(slot, handle);
        clearError();
        updateDisplayedPrice();
        updateAtcState();
      });
    });



    

    async function addPackToCart() {
      clearError();

      const count = packCount();
      const size = selectedSize();
      const pack = selectedPack();
      const selected = getSelectedVariants();
      const prices = calculatePrices();
      const bundleId = makeBundleId();
      const shellPath = window.location.pathname;

      if (selected.length !== count) {
        showError("Please complete your pack before adding to cart.");
        return;
      }

      const items = selected.map((item) => ({
        id: item.variant.id,
        quantity: 1,
        properties: {
          "_bundle_id": bundleId,
          "_bundle_type": "mix-and-match-pack",
          "_bundle_slot": String(item.slot),
          "_bundle_size": size,
          "_bundle_pack_size": pack,
          "_bundle_discount_percent": String(prices.discount)
        }
      }));

      atc.disabled = true;
      atc.classList.add("is-loading");

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || __t("Could not add pack to cart.", "No se pudo añadir el pack al carrito.", "Não foi possível adicionar o kit ao carrinho.", "Impossible d'ajouter le pack au panier.", "Das Pack konnte nicht in den Warenkorb gelegt werden."));
        }

        window.location.href = "/cart";
      } catch (e) {
        showError(e.message || __t("Could not add pack to cart.", "No se pudo añadir el pack al carrito.", "Não foi possível adicionar o kit ao carrinho.", "Impossible d'ajouter le pack au panier.", "Das Pack konnte nicht in den Warenkorb gelegt werden."));
      } finally {
        atc.classList.remove("is-loading");
        updateAtcState();
      }
    }

    if (atc) atc.addEventListener("click", addPackToCart);

    updateRowsAndGallery();
  }

  document.querySelectorAll("[data-pack-builder]").forEach(initPackBuilder);

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-pack-builder]").forEach(initPackBuilder);
  });
})();